import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './VoteModal.module.scss';
import Button from '../Button/Button';
import Modal from '../Modal/Modal';
import ModalCloseButton from '../Modal/ModalCloseButton';

const VoteCozyYamalModal = ({
  isOpen,
  onClose,
}) => {
  const intervalRef = useRef(null);
  const navigate = useNavigate();
  const [sendCode, setSendCode] = useState(null);

  const closeModalWindow = () => {
    onClose();
    navigate('/quiz', { replace: true });
  };

  useEffect(() => {
    if (sendCode === 10) {
      if (intervalRef.current) clearInterval(intervalRef.current);

      intervalRef.current = setInterval(() => {
        setSendCode((prev) => prev - 1);
      }, 1000);
    }

    if (sendCode === 0) {
      clearInterval(intervalRef.current);
      closeModalWindow();
    }
  }, [sendCode]);

  useEffect(() => {
    if (isOpen) {
      setSendCode(10);
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles.innerWrapper}>
        <h4 className={styles.title}>
          Участвуйте в викторине Уютный Ямал
          <ModalCloseButton onClick={onClose} />
        </h4>
        <div className={styles.disclaimer}>
          <p className={styles.text}>
            Ответье правильно на все вопросы викторины и получите приз.
            Переход к викторине произойдет автоматически через
            {' '}
            {sendCode}
            {' '}
            секунд, или нажмите кнопку «Участвовать».
          </p>
          <div className={styles.buttons}>
            <Button
              className={styles.voteBtn}
              typeButton="button-fill"
              onClick={() => closeModalWindow()}
            >
              Участвовать
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

VoteCozyYamalModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};
VoteCozyYamalModal.defaultProps = {
  isOpen: false,
};

export default VoteCozyYamalModal;
